import { render, staticRenderFns } from "./Pakete.vue?vue&type=template&id=42bae48e&"
import script from "./Pakete.vue?vue&type=script&lang=js&"
export * from "./Pakete.vue?vue&type=script&lang=js&"
import style0 from "./Pakete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports